import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CollectionManageAccessFacade } from '@mode/collections/domain';
import { EntitlementUpdateErrorEvent, EntitlementUpdateSuccessEvent } from '@mode/shared/contract-common';
import { merge, Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { InlineToastMessage, InlineToastType } from '../inline-toast/inline-toast.component';

const EntitlementUpdateSuccessMessage: InlineToastMessage = {
  message: 'Updated',
  type: InlineToastType.Success,
};

const EntitlementRemovalSuccessMessage: InlineToastMessage = {
  message: 'Removed',
  type: InlineToastType.Success,
  cover: true,
};

const EntitlementUpdateErrorMessage: InlineToastMessage = {
  message: 'Error',
  type: InlineToastType.Error,
};

@Component({
  selector: 'mode-access-inline-toast',
  templateUrl: './access-inline-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessInlineToastComponent implements OnInit {
  @Input()
  token!: string;

  @Input()
  placement!: string;

  @Output()
  done = new EventEmitter<void>();

  toast$!: Observable<InlineToastMessage>;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private collectionManageAccessFacade: CollectionManageAccessFacade
  ) {}

  ngOnInit(): void {
    this.toast$ = merge(
      this.collectionManageAccessFacade.entitlementUpdateError$.pipe(
        filter(({ entitlementToken }: EntitlementUpdateErrorEvent) => entitlementToken === this.token),
        map(() => ({ ...EntitlementUpdateErrorMessage }))
      ),
      this.collectionManageAccessFacade.entitlementUpdateSuccess$.pipe(
        filter(({ entitlementToken }: EntitlementUpdateSuccessEvent) => entitlementToken === this.token),
        map(() => ({ ...EntitlementUpdateSuccessMessage }))
      ),
      this.collectionManageAccessFacade.entitlementDeleteSuccess$.pipe(
        filter(({ entitlementToken }: EntitlementUpdateSuccessEvent) => entitlementToken === this.token),
        map(() => ({ ...EntitlementRemovalSuccessMessage }))
      )
    ).pipe(tap(() => this.changeDetectorRef.markForCheck()));
  }

  toastComplete() {
    setTimeout(() => {
      this.collectionManageAccessFacade.updateEntitlementStream();
    });

    this.done.emit();
  }
}
